// Mask patterns
const mask = {
    phoneNumber: "00 xxx xx 00",
    loyaltyCardNumber: "XXX XXX XX0 000X",
    phoneNumberSpaced: "000 000 000",
    postalCode: "0000-000"
};

export { mask };
